import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {DonutChart} from 'shells/charts/donut-chart';
import type {Item} from 'shells/table/item-count-table';

import styles from './industries.module.css';

type Props = {
    width: number;
    industries: Item[];
    getFilteredListUrlPath: (filter: FilterObject) => string;
};

export function IndustriesDonutChart(props: Props) {
    const handlePieClick = (bucket: string) => {
        // Open the filtered visitors list in a new tab
        window.open(props.getFilteredListUrlPath({mcfxIndustry: bucket}), '_blank');
    };

    return (
        <div className={styles['donut-chart-container']}>
            <DonutChart
                width={props.width}
                items={props.industries}
                handlePieClick={handlePieClick}
                singularNoun='company'
                pluralNoun='companies'
            />
        </div>
    );
}
